export default __webpack_public_path__ + "static/media/text-subscriber.f76d83da.svg";